import React, { useRef } from 'react';
import StepWizard from 'react-step-wizard';
import MyText from './MyText';
import {theme} from '../utils/theme';
import { RxCheck } from "react-icons/rx";
import { Style } from 'react-style-tag';
import { useTranslation } from 'react-i18next';
import Button from './Button';
import back from '../assets/back.svg';
import StepCandidatura from './StepCandidatura';
import StepAnagrafica from './StepAnagrafica';
import StepAllegati from './StepAllegati';
import { useMediaQuery } from 'react-responsive';

export default function Wizard(){
    const wizardRef = useRef();
    const [currentStep, setCurrentStep] = React.useState(1);
    const {t} = useTranslation();
    const step1Title = t('form_step1Title');
    const step2Title = t('form_step2Title');
    const step3Title = t('form_step3Title');
    const isNotMobile = useMediaQuery({ query: '(min-width: 768px)' });

    const handleNext = () => {
        setCurrentStep(currentStep + 1);
        wizardRef.current.nextStep();
        window.scrollTo(0, 0)
    }
    const handleBack = () => {
        setCurrentStep(currentStep - 1);
        wizardRef.current.previousStep();
        window.scrollTo(0, 0)
    }

    const StepCounter = ({label, isActive, isDone, stepName}) => {
        return (
            <div className='stepCounterContainer' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                {isNotMobile && <Style>{`
                    .stepCounterContainer:nth-child(1) .stepCounter::after{
                        content: "${step1Title}";
                    }
                    .stepCounterContainer:nth-child(3) .stepCounter::after{
                        content: "${step2Title}";
                    }
                    .stepCounterContainer:nth-child(5) .stepCounter::after{
                        content: "${step3Title}";
                    }
                `}</Style>}
                <div style={{...styles.stepConterContainer,
                    backgroundColor: isActive ? theme.secondary : isDone ? theme.primary : '#C6C6C6',
                }}> 
                    {isDone ? 
                        <RxCheck style={styles.stepCounterIcon} /> : 
                        <MyText style={styles.stepConterText}>{label}</MyText>
                    }
                </div>
                <div className='stepCounter' style={{"--label": stepName}}/>
            </div>
        );
    };

    const StepSummary = () => {
        return (
            <div style={styles.summaryContainer}>
                {!isNotMobile && <Style>{`
                    .stepCounterContainer:nth-child(1) .stepCounter::after{
                        content: "${currentStep === 1 ? step1Title : currentStep === 2 ? step2Title : step3Title}";
                    }
                `}</Style>}
                {(isNotMobile || (!isNotMobile && currentStep === 1)) && <StepCounter label='1' isActive={currentStep === 1} isDone={currentStep > 1} stepName="Anagrafica"/>}
                {isNotMobile && <div style={styles.stepDivider}/>}
                {(isNotMobile || (!isNotMobile && currentStep === 2)) && <StepCounter label='2' isActive={currentStep === 2} isDone={currentStep > 2} stepName="Candidatura"/>}
                {isNotMobile && <div style={styles.stepDivider}/>}
                {(isNotMobile || (!isNotMobile && currentStep === 3)) && <StepCounter label='3' isActive={currentStep === 3} isDone={currentStep > 3} stepName="Allegati"/>}
            </div>
        );
    };

    const StepBack = () => {
        return(
            <div style={styles.stepBackContainer}>
                <Button style={styles.stepBackButton} onClick={handleBack}>
                    <img src={back} alt='back' style={{width: 20, height: 20}}/>
                </Button>
            </div>
        );
    }

    return (
        <div style={{...styles.container, marginTop: currentStep === 1 ? 60 : 20}}>
            {currentStep !== 1 && <StepBack/>}
            <StepSummary/>
            <StepWizard ref={wizardRef} transitions={{}}>
                <StepAnagrafica nextCallback={handleNext}/>
                <StepCandidatura nextCallback={handleNext}/>
                <StepAllegati />
            </StepWizard>
        </div>
    );
};
const styles = {
    container: {
        width: '80%',
        maxWidth: 700,
        // width: 'clamp(60%, 20vw, 100%)',
        marginBottom: 20,
    },
    summaryContainer:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        gap: 10,
        marginBottom: 80,
        width: '100%',
        // minWidth: 200,
    },
    stepConterContainer:{
        // display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '50%',
        width: 30,
        height: 30,
        padding: 5,
    },
    stepCounterIcon:{
        color: 'black',
        fontSize: '1.5rem',
    },
    stepConterText:{
        fontSize: '1.2rem',
    },
    stepDivider:{
        height: 1,
        // minWidth: 80,
        width: '100%',
        maxWidth: 160,
        flex:1,
        backgroundColor: 'black',
    },
    stepBackContainer:{
        position: 'relative',
        top: 0,
        left: '0',
        marginBottom: 20,
    },
    stepBackButton:{
        padding: '0.5rem 1.5rem',
        borderRadius: '0.5rem',
        border: 'none',
        backgroundColor: theme.primary,
        color: theme.text,
        cursor: 'pointer',
        fontSize: '1rem',
        height: 'fit-content',
        boxShadow: '0px 0px 4px 2px #00000022',
    }
};